export default __webpack_public_path__ + "static/media/c2db96f4cbf1e0b1ef2b65074f64a2841576516429414.d46fb41c.webp";